<template>
  <main class="event-detail-page">
    <HeroSection :event="event" />
    <ContentSection :event="event" />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import ContentSection from './ContentSection/ContentSection.vue';

export default {
  components: {
    HeroSection,
    ContentSection,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './EventDetailPage.scss';
</style>
